"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeInline;

function removeInline(array) {
  for (var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    items[_key - 1] = arguments[_key];
  }

  items.forEach(function (item) {
    var index;

    while (~(index = array.indexOf(item))) {
      array.splice(index, 1);
    }
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9yZW1vdmVJbmxpbmUuanMiXSwibmFtZXMiOlsicmVtb3ZlSW5saW5lIiwiYXJyYXkiLCJpdGVtcyIsImZvckVhY2giLCJpdGVtIiwiaW5kZXgiLCJpbmRleE9mIiwic3BsaWNlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EsWUFBVCxDQUFzQkMsS0FBdEIsRUFBdUM7QUFBQSxvQ0FBUEMsS0FBTztBQUFQQSxJQUFBQSxLQUFPO0FBQUE7O0FBQ3BEQSxFQUFBQSxLQUFLLENBQUNDLE9BQU4sQ0FBYyxVQUFBQyxJQUFJLEVBQUk7QUFDcEIsUUFBSUMsS0FBSjs7QUFFQSxXQUFPLEVBQUVBLEtBQUssR0FBR0osS0FBSyxDQUFDSyxPQUFOLENBQWNGLElBQWQsQ0FBVixDQUFQLEVBQXVDO0FBQ3JDSCxNQUFBQSxLQUFLLENBQUNNLE1BQU4sQ0FBYUYsS0FBYixFQUFvQixDQUFwQjtBQUNEO0FBQ0YsR0FORDtBQU9EIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiByZW1vdmVJbmxpbmUoYXJyYXksIC4uLml0ZW1zKSB7XG4gIGl0ZW1zLmZvckVhY2goaXRlbSA9PiB7XG4gICAgbGV0IGluZGV4O1xuXG4gICAgd2hpbGUgKH4oaW5kZXggPSBhcnJheS5pbmRleE9mKGl0ZW0pKSkge1xuICAgICAgYXJyYXkuc3BsaWNlKGluZGV4LCAxKTtcbiAgICB9XG4gIH0pO1xufVxuIl19